import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { useCurrencyStore } from "@faire/web--source/common/currency/CurrencyStore";
import { moneyOrZero } from "@faire/web--source/common/money";
import { useState } from "@faire/web--source/ui/hooks/useState";
import { useEffect } from "react";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { useFetchCachedBrandView } from "@faire/retailer-visitor-shared/views/brand/hooks/useFetchCachedBrandView";
export var useBrandCartHeader = function(brandToken) {
    var _useRetailerStore = useRetailerStore([
        "isNewOrMigratedCanadian",
        "displayCurrency",
        "isQualifiedForEuropeFreeShipping"
    ]), isNewOrMigratedCanadian = _useRetailerStore.isNewOrMigratedCanadian, displayCurrency = _useRetailerStore.displayCurrency, isQualifiedForEuropeFreeShipping = _useRetailerStore.isQualifiedForEuropeFreeShipping;
    var _useState = _sliced_to_array(useState(false), 2), isBrandEligibleForUkEuBrandsFreeShipping = _useState[0], setIsBrandEligibleForUkEuBrandsFreeShipping = _useState[1];
    var setCurrency = useCurrencyStore([
        "setCurrency"
    ]).setCurrency;
    useEffect(function() {
        // TODO(bocong.zhao@faire.com, 2024/02/14): Remove when we relaunch Canada.
        if (isNewOrMigratedCanadian) {
            setCurrency(undefined);
        }
    }, [
        isNewOrMigratedCanadian,
        setCurrency
    ]);
    var data = useFetchCachedBrandView(brandToken !== null && brandToken !== void 0 ? brandToken : "").data;
    var brand = data === null || data === void 0 ? void 0 : data.brand;
    var _data_faire_funded_promo;
    var faireFundedPromos = (_data_faire_funded_promo = data === null || data === void 0 ? void 0 : data.faire_funded_promo) !== null && _data_faire_funded_promo !== void 0 ? _data_faire_funded_promo : [];
    var brandMinimumAmount = moneyOrZero(brand === null || brand === void 0 ? void 0 : brand.minimum_order_amount, displayCurrency);
    var _brand_is_apparel;
    var showVerticalImagery = (_brand_is_apparel = brand === null || brand === void 0 ? void 0 : brand.is_apparel) !== null && _brand_is_apparel !== void 0 ? _brand_is_apparel : false;
    var fetchFreeShippingStatus = function(retailerToken) {
        if (!retailerToken) {
            return;
        }
        var _data_eligible_for_uk_eu_brands_free_shipping;
        setIsBrandEligibleForUkEuBrandsFreeShipping((_data_eligible_for_uk_eu_brands_free_shipping = data === null || data === void 0 ? void 0 : data.eligible_for_uk_eu_brands_free_shipping) !== null && _data_eligible_for_uk_eu_brands_free_shipping !== void 0 ? _data_eligible_for_uk_eu_brands_free_shipping : false);
    };
    var hasUkEuBrandsFreeShipping = isQualifiedForEuropeFreeShipping && isBrandEligibleForUkEuBrandsFreeShipping;
    var _brand_is_first_order;
    return {
        brand: brand,
        firstOrder: (_brand_is_first_order = brand === null || brand === void 0 ? void 0 : brand.is_first_order) !== null && _brand_is_first_order !== void 0 ? _brand_is_first_order : false,
        brandMinimumAmount: brandMinimumAmount,
        brandName: brand === null || brand === void 0 ? void 0 : brand.name,
        showVerticalImagery: showVerticalImagery,
        faireFundedPromos: faireFundedPromos,
        fetchFreeShippingStatus: fetchFreeShippingStatus,
        hasUkEuBrandsFreeShipping: hasUkEuBrandsFreeShipping
    };
};
